<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>问卷调查维护</p>
    </div>
    <div class="panel-content center_content">
      <div class="course_info">
        <div>
          <p></p>
          <p></p>
        </div>
      </div>
      <div class="list">
        <h2>{{ surveyInfo ? surveyInfo.title : '' }}</h2>
        <hr>
        <ul>
          <li
            v-for="(question, index) in questions"
            :key="index"
          >
            <div>
              <span class="question-title">{{ index + 1 }}.</span>
              <span
                class="question-title"
                v-html="question.content"
              ></span>
              <span
                class="question-del"
                @click="delSurveyQuestion(question)"
              >删除</span>
            </div>
            <div>
              <ul class="question-list">
                <li
                  v-for="(option, op_index) in question.options"
                  :key="op_index"
                ><input :type="question.questionType == 1 ? 'radio' : 'checkbox'">{{ option.code }}. {{ option.title }}</li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
      <div class="footer-btn">
        <div
          class="add-btn"
          @click="showAddWindow"
        >添加题目</div>
      </div>
    </div>
    <!-- 新增/编辑弹窗 -->
    <div
      class="form_overlay"
      :style="classShowAddWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">添加题目</div>
        <div class="form_content">
          <form id="itemForm">
            <div class="item">
              <vue-ueditor-wrap
                :config="editorConfig"
                v-model="formInfo.content"
                editor-id="editor-demo-01"
              ></vue-ueditor-wrap>
            </div>
            <div class="item">
              <span class="label"><i class="require">*</i>试题类型:</span>
              <select
                class="s-select separate"
                v-model="formInfo.questionType"
              >
                <option :value="1">单选题</option>
                <option :value="2">多选题</option>
              </select>
            </div>
            <div class="item add-item">
              <span class="label"><i class="require">*</i>选项:</span>
              <div v-if="formInfo.questionType==1 || formInfo.questionType==2">
                <div
                  v-for='(item,index) in optionInfo'
                  :key="index"
                >
                  <div v-if="formInfo.questionType==1">
                    <input
                      type="text"
                      v-model="item.title"
                      autocomplete="off"
                      maxlength="25"
                    >
                    <span
                      class="del"
                      @click="delOption(index)"
                    >x</span>
                  </div>
                  <div v-if="formInfo.questionType==2">
                    <input
                      type="text"
                      v-model="item.title"
                      autocomplete="off"
                      maxlength="25"
                    >
                    <span
                      class="del"
                      @click="delOption(index)"
                    >x</span>
                  </div>

                </div>
                <span
                  class="add-option"
                  @click="addOption"
                >添加一个选项</span>
              </div>
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            class="button close"
            id="form_close"
            @click="hideAddWindow"
          >取消</a>
          <a
            href="javascript:;"
            class="button"
            id="form_submit"
            @click="saveInfo"
          >提交</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap'

export default {
  name: 'StationResearchDetail',
  components: {
    VueUeditorWrap
  },
  data() {
    return {
      classShowAddWindow: {
        visibility: 'hidden'
      },
      editorConfig: {
        // 访问 UEditor 静态资源的根路径，可参考 https://hc199421.gitee.io/vue-ueditor-wrap/#/faq
        UEDITOR_HOME_URL: '/UE/',
        // 服务端接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        // serverUrl: '//ueditor.szcloudplus.com/cos',
        serverUrl: this.$store.state.uEditorServerUrl,
        autoHeight: true,
        // imagePathFormat: '/files/{yyyy}{mm}{dd}-{time}{rand:6}',
        // imageUrlPrefix: 'http://localhost:8000'
        initialFrameWidth: '100%',
        initialFrameHeight: 300
      },
      formInfo: {
        survey_id: this.$route.query.survey_id,
        questionType: 1,
        content: ''
      },
      optionInfo: [],
      surveyInfo: null,
      allQuestion: [],
      allOption: [],
      sensitiveWord: []
    }
  },
  methods: {
    showAddWindow() {
      this.classShowAddWindow = {
        visibility: 'visible'
      }
    },
    hideAddWindow() {
      this.classShowAddWindow = {
        visibility: 'hidden'
      }
      this.formInfo = {
        survey_id: this.$route.query.survey_id,
        questionType: 1,
        content: ''
      }
      this.optionInfo = []
    },
    addOption() {
      const option = {
        question_id: '',
        title: ''
      }
      this.optionInfo.push(option)
    },
    delOption(index) {
      this.optionInfo.splice(index, 1)
    },
    async saveInfo() {
      if (!this.optionInfo.length) {
        this.$layer.msg('请添加试题选项！')
        return
      }
      var checkTitle = this.optionInfo.some((item) => {
        return item.title === ''
      })
      if (checkTitle) {
        this.$layer.msg('请填写选项内容')
        return
      }
      if (this.optionInfo.length === 1) {
        this.$layer.msg('请至少添加两个选项！')
      }
      const data = {
        survey_id: this.$route.query.survey_id,
        questionType: this.formInfo.questionType,
        content: this.formInfo.content,
        options: []
      }
      for (let i = 0; i < this.optionInfo.length; i++) {
        data.options.push({
          title: this.optionInfo[i].title
        })
      }
      const isRight = this.utils.getWords(this.formInfo.content, this.sensitiveWord)
      if (isRight) {
        this.$layer.msg('输入的内容有敏感词!')
        return false
      }
      await this.$http.post('/web_survey_question_save/', {
        json_data: JSON.stringify(data)
      }).then((data) => {
        if (data.code === '200') {
          this.$parent.showMsg('添加成功！')
          this.hideAddWindow()
          this.search()
        } else {
          this.$parent.showMsg('添加失败！')
        }
      })
    },
    async search () {
      await this.$http.get('/web_survey/' + this.$route.query.survey_id + '/').then((data) => {
        this.surveyInfo = data
      })

      if (this.surveyInfo) {
        await this.$http.get('/web_survey_question/', {
          params: {
            page: 1,
            size: 10000,
            survey_id: this.surveyInfo.id
          }
        }).then((data) => {
          this.allQuestion = data.results
        })

        await this.$http.get('/web_survey_question_option/', {
          params: {
            page: 1,
            size: 10000,
            survey_id: this.surveyInfo.id
          }
        }).then((data) => {
          this.allOption = data.results
        })
      }
    },
    delSurveyQuestion (item) {
      this.$parent.showConfirm('确定要删除吗？', async () => {
        await this.$http.put('/web_survey_question/' + item.id + '/', {
          isdel: 1
        }).then((data) => {
          this.search()
        })
      })
    },
    // 获取敏感词
    async getSensitiveWord() {
      await this.$http.get('/sensitiveword/', {
        params: {
          page: 1,
          size: 10000,
          status: 1
        }
      }).then((data) => {
        if (data.results.length) {
          data.results.forEach(item => {
            if (item.words) {
              const wordList = item.words.split('\n')
              for (let i = 0; i < wordList.length; i++) {
                this.sensitiveWord.push(wordList[i])
              }
            }
          })
        } else {
          this.sensitiveWord = []
        }
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  mounted() {
    this.search()
    this.getSensitiveWord()
  },
  computed: {

    questions () {
      const data = []
      for (let i = 0; i < this.allQuestion.length; i++) {
        const question = this.allQuestion[i]
        question.options = []
        for (let j = 0; j < this.allOption.length; j++) {
          if (this.allOption[j].surveyQuestion_id === question.id) {
            question.options.push(this.allOption[j])
          }
        }
        data.push(question)
      }
      return data
    }
  }
}
</script>

<style lang="less" scoped>
#panel {
  .panel-content {
    padding: 20px 40px;
    .course_info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      .panel-title {
        p {
          display: inline-block;
          margin-right: 20px;

          &:last-child {
            color: #999;
            font-size: 16px;
          }
        }
      }
      .course_btn {
        div {
          margin-left: 20px;
          padding: 7px 20px;
          background: #73D6CA;
          color: #fff;
          border-radius: 3px;
          &:first-child {
            background: #25c7a8;
          }
          &:nth-child(2) {
            border: 1px solid #73D6CA;
            color: #73D6CA;
            background: #fff;
          }
        }
      }
    }
    .list {
      h2 {
        text-align: center;
      }
      .question-title {
        font-size: 18px;
        display: inline-block;
      }
      .question-del {
        border: 1px solid indianred;
        border-radius: 3px;
        padding: 2px 4px;
        color: indianred;
        float: right;
      }
      .question-list {
        margin: 10px 10px 30px 10px;
      }
      .question-list > li {
        font-size: 16px;
        margin: 4px;
        input {
          margin-right: 5px;
        }
      }
    }
    .footer-btn {
      text-align: center;
      .add-btn {
        padding-left: 15px;
        padding-right: 15px;
      }
    }
  }
}

.add-option {
  padding: 5px 10px;
  border: 1px solid #ccc;
  background: #eee;
  cursor: pointer;
}
.add-item {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  .item {
    .label {
      padding-left: 0;
    }
  }
}
</style>
